module.exports = __webpack_public_path__ + "ca.7e994bdcb7a3367f98e2.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ca.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ca.svg
// module chunks = styles